mutation PurchaseOrderEntryStampProcessing(
  $input: PurchaseOrderEntryStampProcessingInput!
) {
  purchaseOrderEntryStampProcessing(input: $input) {
    processRequests {
      message
      isWarning
      isSuccess
      isFail
      id
      rowTimestamp
      reference
    }
  }
}
